import React from 'react';
import PropTypes from 'prop-types';
import BasicInput from './BasicInput';

const AccuontNumberInput = (props) => {
  const routingValidator = v => {
    return v.length >= 4 && v.length <= 17;
  };
  const shouldTriggerChangeEvent = new RegExp('^\\d{0,17}$');
  const onChange = (value) => {
    if (props.onChange && shouldTriggerChangeEvent.test(value)) {
      props.onChange(value);
    }
  };
  return (<BasicInput {...props} validator={routingValidator} errorMessage="Please enter a valid bank account number." onChange={onChange}/>);
};

AccuontNumberInput.propTypes = {
  onChange: PropTypes.func
};

export default AccuontNumberInput;



// WEBPACK FOOTER //
// ./src/components/common/Input/AccountNumberInput.js